import { useState } from "react";
import { faqList } from "@/mocks/chigua";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <div className="text-center">
          <p className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-sm font-semibold text-primary-700">
            <i className="ri-question-answer-fill" aria-hidden="true"></i> 常见问题
          </p>
          <h2 className="mt-3 font-display text-3xl text-foreground-900 md:text-4xl">
            关于爆炸瓜,你可能想了解
          </h2>
        </div>

        <div className="mx-auto mt-8 max-w-3xl space-y-3">
          {faqList.map((f, idx) => {
            const isOpen = openIdx === idx;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border bg-background-50 transition ${
                  isOpen ? "border-primary-300" : "border-secondary-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? null : idx)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center gap-4 px-5 py-4 text-left"
                >
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-100 text-sm font-bold text-accent-700">
                    Q
                  </span>
                  <h3 className="flex-1 text-sm font-bold text-foreground-900 md:text-base">
                    {f.q}
                  </h3>
                  <i
                    className={`text-xl text-primary-500 transition-transform duration-300 ${
                      isOpen ? "rotate-180" : ""
                    } ${isOpen ? "ri-subtract-line" : "ri-add-line"}`}
                    aria-hidden="true"
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-16 text-sm leading-relaxed text-foreground-600">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}